export default {
  height: '600px',
  avoidInlineStyle: 1,
  fromElement: 1,
  showOffsets: 1,
  allowScripts: 1,
  jsInHtml: true,
  forceClass: false,
  colorPicker: {
    appendTo: 'parent',
    offset: { top: 26, left: -166, },
  },
  canvas: {
    styles: [
      'https://cdn.jsdelivr.net/npm/bulma@0.9.x/css/bulma.min.css',
      'https://cdn.jsdelivr.net/npm/@mdi/font@7.x/css/materialdesignicons.min.css',
    ]
  },
}
